const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `У модронов есть необъяснимая особенность принимать золотых драконов за своего лидера, Прайма. Драконы не возражают, и модроны, кажется, тоже не возражают. Так почему я нахожу это столь оскорбительным?`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
